export default class PartnerTrackingService {

    constructor() {
        this.partnerTrackingObj = 'partnerTrackObj'
        this.partnerTrackingSessionObj = sessionStorage.getItem(this.partnerTrackingObj);
    }

    /**
     * Get a partnerTracking object from session. If the session is not
     * found, it returns an empty object.
     *
     * @returns object
     */
    getPartnerTrackingObj() {
        try {
            let authPartnerId = JSON.parse(this.partnerTrackingSessionObj).authPartnerId
            return { 'authPartnerId': authPartnerId };
        } catch (error) {
            return {}
        }
    }

    /**
     * Check if the subscriber is onboarding for the first time
     * @returns boolean
     */
    isPartnerOnBoarding() {
        try {
            return JSON.parse(this.partnerTrackingSessionObj).isOnBoarding
        } catch (e) {
            return false;
        }
    }

    /**
     * Remove partner tracking object from session storage if found.
     */
    removePartnerTrackingObj() {
        if (sessionStorage.getItem(this.partnerTrackingObj)) {
            sessionStorage.removeItem(this.partnerTrackingObj);
        }
    }

    /**
     * Track subscriber through partner onetime when onboard to the service.
     * isPartnerOnboarding is registered in local session in partner route
     * Due to whos watching is an overlay to homepage when onboarding,
     * tracking only happens when subscriber is redirected back.
     */
    trackHomepage() {
        let partnerTrackingObj = this.getPartnerTrackingObj();
        let isPartnerOnBoarding = this.isPartnerOnBoarding();

        let partnerOnBoardingCountKey = 'partner_onboarding_count';
        let partnerOnBoardingCount = sessionStorage.getItem(partnerOnBoardingCountKey);

        if (partnerOnBoardingCount == null && isPartnerOnBoarding === true) {
            sessionStorage.setItem(partnerOnBoardingCountKey, 1);
        }

        if (partnerTrackingObj.hasOwnProperty('authPartnerId') &&
            partnerOnBoardingCount > 0 &&
            isPartnerOnBoarding === true) {
            let checkOm = setInterval(function () {
                if (typeof om != "undefined") {
                    try {
                        om.trackState(partnerTrackingObj)
                    } catch (e) {
                        console.error(e);
                    }
                    clearInterval(checkOm)
                }
            }, 200)

            this.removePartnerTrackingObj();
            sessionStorage.removeItem(partnerOnBoardingCountKey);
        }
    }
}